import { SOLE_TRADER } from './actions';
import {
  KEY_YES,
  REGISTER_ADDRESS_TYPE,
  KEY_NO,
  PERSONAL_ADDRESS_TYPE,
  TRADING_ADDRESS_TYPE,
  DIFFERENT_ADDRESS_TYPE,
  MAILING_ADDRESS_TYPE
} from '../../utils/constants';
import { CHOOSE_ADD } from '../../components/Address/addressUtils/addressConstants';
import { dataCaptureSelectors } from '../../store/dataCapture';
const MANUALLY_CLICKED = 'ManuallyClicked';
const MAX_CHAR_LIMIT = 40;
const BUSINESS_ACCOUNT = 'Business Account';
let currentAddressType;
export const getRegisterAddress = (state, addressType) => {
  const regAddressSelector = state.dataCapture.get('registerAddressSelector');
  const businessType = state.dataCapture.get('businessTypeField');
  const type = addressType || REGISTER_ADDRESS_TYPE;
  if (businessType === SOLE_TRADER) {
    return {
      registered_company: {
        name: getTradingName(state)
      }
    };
  } else if (regAddressSelector) {
    if (regAddressSelector.toLowerCase() === KEY_YES) {
      return getUkAddressFromPostCode(state.cases.toJS().personalAddress, type);
    } else if (
      regAddressSelector.toLowerCase() === KEY_NO &&
      !isAddManuallyClickedByType(state, REGISTER_ADDRESS_TYPE)
    ) {
      return getUkAddressFromPostCode(state.address.toJS().registerSelectedAddress, type);
    }
    return getUkAddress(state.dataCapture.toJS().register, type);
  }
  return generateAddressPayload(
    { uk_address: dataCaptureSelectors.getRegisterAddressObject(state) },
    addressType
  );
};

export const getAddressByType = (state, type) => {
  const dataCapture = state.dataCapture.toJS();
  currentAddressType = type;
  const condition =
    type === TRADING_ADDRESS_TYPE || dataCapture.mutipleAddressMailing === TRADING_ADDRESS_TYPE
      ? dataCapture.mutipleAddressTrading
      : dataCapture.mutipleAddressMailing;
  switch (condition) {
    case PERSONAL_ADDRESS_TYPE:
      return getUkAddressFromPostCode(state.cases.toJS().personalAddress, type);
    case REGISTER_ADDRESS_TYPE:
      return getRegisterAddress(state, type);
    case TRADING_ADDRESS_TYPE:
      return getAddressByType(state, type);
    case DIFFERENT_ADDRESS_TYPE:
      return getDifferentAddress(state, getDifferentAddressType(condition, type, dataCapture));
  }
  const address = dataCaptureSelectors.getAddressObjectByType(
    state,
    getAddressType(dataCapture, type)
  );
  address.type = currentAddressType.toUpperCase();
  return address;
};

const generateAddressPayload = (object, type) => {
  if (type && type !== REGISTER_ADDRESS_TYPE) {
    return Object.assign({}, object, { type: type.toUpperCase() });
  }
  return object;
};

const getAddressType = (dc, type) =>
  type === MAILING_ADDRESS_TYPE
    ? dc.mutipleAddressMailing || type
    : dc.mutipleAddressTrading || type;

const getDifferentAddressType = (condition, type, dc) =>
  condition === DIFFERENT_ADDRESS_TYPE && type === MAILING_ADDRESS_TYPE
    ? dc.mutipleAddressMailing === DIFFERENT_ADDRESS_TYPE
      ? type
      : dc.mutipleAddressMailing
    : type;

const getUkAddress = (state, type) => {
  const addressPayload = {
    uk_address: {
      organisation_name: state.organisation_name,
      address_prefix: state.local.FlatNumber || state.registerFlatNumber,
      house_number: state.local.BuildingNumber,
      house_name: state.local.HouseName,
      street: state.local.StreetName || state.local.addressline2,
      city: state.local.CityName,
      county: state.local.county,
      postal_code: state.postcode || state.postal_code
    }
  };
  return type !== REGISTER_ADDRESS_TYPE
    ? Object.assign({}, addressPayload, { type: type.toUpperCase() })
    : addressPayload;
};

const getUkAddressFromPostCode = (state, type) => {
  const addressPayload = {
    uk_address: {
      organisation_name: state.organisation_name,
      address_prefix: state.address_prefix,
      house_number: state.house_number || '',
      house_name: state.house_name || '',
      street: state.street_name || state.street || state.address_line2,
      city: state.city,
      county: state.county,
      postal_code: state.postcode || state.postal_code,
      address_reference: state.id
    }
  };
  return type !== REGISTER_ADDRESS_TYPE
    ? Object.assign({}, addressPayload, { type: type.toUpperCase() })
    : addressPayload;
};
const getInternationalAddress = (state, type) => {
  return {
    international_address: {
      address_line1: state.international.AddressLine1,
      address_line2: state.international.AddressLine2 || '',
      address_line3: state.international.AddressLine3 || '',
      address_line4: state.international.CityNameInt || '',
      country: state.international.CountryNameInt
    },
    type: type.toUpperCase()
  };
};

export const getTradingName = (state) => {
  const reg_name_withTradingName = `${state.cases.get('tradingFirstName')} ${state.cases.get(
    'tradingLastName'
  )} t/a ${state.dataCapture.get('tradingName')}`;
  const reg_name_missingTrading = `${state.cases.get('tradingFirstName')} ${state.cases.get(
    'tradingLastName'
  )} ${BUSINESS_ACCOUNT}`;

  if (state.dataCapture.get('tradingName') && validateStringLength(reg_name_withTradingName)) {
    return reg_name_withTradingName;
  } else if (
    !state.dataCapture.get('tradingName') &&
    validateStringLength(reg_name_missingTrading)
  ) {
    return reg_name_missingTrading;
  }
  return `${state.cases.get('tradingFirstName')} ${state.cases.get('tradingLastName')}`;
};

const validateStringLength = (name) => {
  return name && name.length <= MAX_CHAR_LIMIT ? true : false;
};

const isAddManuallyClickedByType = (state, type) => {
  return state.address.get(`${type}${MANUALLY_CLICKED}Value`);
};

const getDifferentAddress = (state, type) => {
  if (isAddManuallyClickedByType(state, type)) {
    const dataCapture = state.dataCapture.toJS();
    const chooseAdd = dataCapture[type][CHOOSE_ADD];
    return chooseAdd && chooseAdd.toLowerCase() === KEY_YES
      ? getUkAddress(dataCapture[type], currentAddressType)
      : getInternationalAddress(dataCapture[type], currentAddressType);
  }
  return getUkAddressFromPostCode(
    state.address.toJS()[`${type}SelectedAddress`],
    currentAddressType
  );
};
